import React from "react";

const RADIUS_OPTIONS = [
  { value: "", label: "Any distance" },
  { value: "1", label: "1 mile" },
  { value: "5", label: "5 miles" },
  { value: "10", label: "10 miles" },
  { value: "25", label: "25 miles" },
  { value: "50", label: "50 miles" },
  { value: "100", label: "100 miles" },
];

function RadiusSlider({ value, onChange }) {
  return (
    <div className="search-radius">
      <form className="search-input-wrap location-radius">
        <label className="label-no-transform" htmlFor="radius-dropdown">Within:</label>
        <div className="radius-container">
          <span className="select-wrap">
            <select className="select" id="radius-dropdown" name="radius"
              value={value || ""}
              onChange={(e) => onChange(e.target.value ? parseInt(e.target.value) : null)}
            >
              {RADIUS_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </span>
        </div>
      </form>
    </div>
  );
}

export default RadiusSlider;
